import request from '../utils/request'

// ── 管理员 ──
export function login(data) {
  return request.post('/admin/login', data)
}

export function enroll(data) {
  return request.post('/admin/enroll', data, { authType: 'admin' })
}

export function getStudents(params) {
  return request.get('/admin/students', { params, authType: 'admin' })
}

export function getPrivateStudents(params) {
  return request.get('/admin/private/students', { params, authType: 'admin' })
}

export function getStudent(id) {
  return request.get(`/admin/students/${id}`, { authType: 'admin' })
}

export function registerFace(id, faceImage) {
  return request.post(`/admin/students/${id}/face`, { faceImage }, { authType: 'admin' })
}

export function recharge(id, data) {
  return request.post(`/admin/students/${id}/recharge`, data, { authType: 'admin' })
}

export function privateRecharge(id, data) {
  return request.post(`/admin/private/students/${id}/recharge`, data, { authType: 'admin' })
}

export function uploadAdminFile(file) {
  const form = new FormData()
  form.append('file', file)
  return request.post('/admin/content/upload', form, {
    authType: 'admin',
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function getStudentEnrollments(id, params) {
  return request.get(`/admin/students/${id}/enrollments`, { params, authType: 'admin' })
}

export function deductHours(id, data) {
  return request.post(`/admin/students/${id}/deduct`, data, { authType: 'admin' })
}

/** 调整课时（增加/减少），录错更正用 */
export function adjustHours(id, data) {
  return request.post(`/admin/students/${id}/adjust-hours`, data, { authType: 'admin' })
}

/** 大课手工签到（选人） */
export function manualCheckIn(id, data) {
  return request.post(`/admin/students/${id}/manual-check-in`, data || {}, { authType: 'admin' })
}

export function deleteStudent(id) {
  return request.delete(`/admin/students/${id}`, { authType: 'admin' })
}

export function updateStudent(id, data) {
  return request.put(`/admin/students/${id}`, data, { authType: 'admin' })
}

export function openAnnualCard(id, data) {
  return request.post(`/admin/students/${id}/annual-card`, data, { authType: 'admin' })
}

export function getCheckInRecords(params) {
  return request.get('/admin/check-in-records', { params, authType: 'admin' })
}

export function getFaceSettings() {
  return request.get('/admin/settings/face', { authType: 'admin' })
}

export function updateFaceSettings(similarityThresholdPercent) {
  return request.put('/admin/settings/face', { similarityThresholdPercent }, { authType: 'admin' })
}

export function getPrivateExchangeSettings() {
  return request.get('/admin/settings/private-exchange', { authType: 'admin' })
}

export function updatePrivateExchangeSettings(defaultRate) {
  return request.put('/admin/settings/private-exchange', { defaultRate }, { authType: 'admin' })
}

export function updatePrivateExchange(id, data) {
  return request.post(`/admin/students/${id}/private-exchange`, data, { authType: 'admin' })
}

export function listAdminCoaches(params) {
  return request.get('/admin/content/coaches', { params: params || { page: 1, size: 50 }, authType: 'admin' })
}

export function saveCoach(data) {
  return data && data.id
    ? request.put(`/admin/content/coaches/${data.id}`, data, { authType: 'admin' })
    : request.post('/admin/content/coaches', data || {}, { authType: 'admin' })
}

export function deleteCoach(id) {
  return request.delete(`/admin/content/coaches/${id}`, { authType: 'admin' })
}

export function bindPrivateCoach(id, privateCoachId) {
  return request.post(`/admin/students/${id}/private-coach`, { privateCoachId }, { authType: 'admin' })
}

export function batchManualCheckIn(data) {
  return request.post('/admin/students/manual-check-in/batch', data || {}, { authType: 'admin' })
}

export function batchPrivatePunch(data) {
  return request.post('/admin/private/records/batch', data || {}, { authType: 'admin' })
}

export function privatePunch(data) {
  return request.post('/admin/private/records', data, { authType: 'admin' })
}

export function getPrivateRecords(params) {
  return request.get('/admin/private/records', { params, authType: 'admin' })
}

export function deletePrivateRecord(id) {
  return request.delete(`/admin/private/records/${id}`, { authType: 'admin' })
}

export function searchHourAudit(params) {
  return request.get('/admin/hour-audit', { params, authType: 'admin' })
}

export function getStudentHourAudit(id) {
  return request.get(`/admin/students/${id}/hour-audit`, { authType: 'admin' })
}

export function getHoursLowSettings() {
  return request.get('/admin/settings/hours-low', { authType: 'admin' })
}

export function updateHoursLowSettings(threshold, template) {
  const body = { threshold }
  if (template != null) body.template = template
  return request.put('/admin/settings/hours-low', body, { authType: 'admin' })
}

export function sendAdminNotification(data) {
  return request.post('/admin/notifications/send', data || {}, { authType: 'admin' })
}

export function listGroupSessions(params) {
  return request.get('/admin/group-sessions', { params, authType: 'admin' })
}

export function getGroupSession(id) {
  return request.get(`/admin/group-sessions/${id}`, { authType: 'admin' })
}

export function createGroupSession(data) {
  return request.post('/admin/group-sessions', data, { authType: 'admin' })
}

export function cancelGroupSignup(sessionId, signupId, remark) {
  return request.post(
    `/admin/group-sessions/${sessionId}/signups/${signupId}/cancel`,
    { remark: remark || '' },
    { authType: 'admin' }
  )
}

export function adjustGroupSignupHours(sessionId, signupId, hours, remark) {
  return request.post(
    `/admin/group-sessions/${sessionId}/signups/${signupId}/hours`,
    { hours, remark: remark || '' },
    { authType: 'admin' }
  )
}

export function addGroupSignup(sessionId, studentId, remark) {
  return request.post(
    `/admin/group-sessions/${sessionId}/signups`,
    { studentId, remark: remark || '' },
    { authType: 'admin' }
  )
}

export function settleGroupSession(sessionId) {
  return request.post(`/admin/group-sessions/${sessionId}/settle`, {}, { authType: 'admin' })
}

// ── 公众端 / 家长 ──
export function faceCheckIn(faceImage, hoursDeducted = 1, clubCode, courseType = 1, useGroupExchange = false) {
  return request.post('/miniapp/face-check-in', {
    faceImage,
    hoursDeducted,
    courseType: courseType || 1,
    clubCode: clubCode || localStorage.getItem('club_code') || '',
    useGroupExchange: !!useGroupExchange
  }, { authType: 'admin', silentBizError: true })
}

export function changeAdminPassword(data) {
  return request.post('/admin/password', data, { authType: 'admin' })
}

export function updateParentDefaultPassword(password) {
  return request.put('/admin/club/parent-default-password', { password }, { authType: 'admin' })
}

export function parentLogin(phone, password, clubCode) {
  return request.post('/miniapp/parent/login', {
    phone,
    password,
    clubCode: clubCode || localStorage.getItem('club_code') || ''
  })
}

export function parentLogoutApi() {
  return request.post('/miniapp/parent/logout', {}, { authType: 'parent' })
}

export function listPlatformClubs() {
  return request.get('/admin/platform/clubs', { authType: 'admin' })
}

export function updatePlatformContentModules(id, data) {
  return request.put(`/admin/platform/clubs/${id}/content-modules`, data, { authType: 'admin' })
}

export function getParentProfile() {
  return request.get('/miniapp/parent/profile', { authType: 'parent' })
}

export function getParentCheckInRecords(params) {
  return request.get('/miniapp/check-in-records', { params, authType: 'parent' })
}

export function getParentPrivateRecords(params) {
  return request.get('/miniapp/parent/private/records', { params, authType: 'parent' })
}
